import {SxType} from "@baseTypes/sx/sxTypes";

export const sx: SxType = {
    root: {
        borderRadius: '50%',
        boxShadow: '0 0 4px 0 rgba(0, 0, 0, 0.15)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '30px',
        height: '30px',
        position: 'relative',
        zIndex: 55,
        transition: 'all .3s',

        '&:hover:hover': {
            cursor: 'pointer'
        }
    },
    inner: {
        position: 'relative',
    }
}